var _defs, _path, _g, _path2, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1200,
    height: 600,
    viewBox: "0 0 120 60",
    fill: "#fedd00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h120v60H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v15h62v16zm0 30v1h30V0h30z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m0-5.257 3.09 9.51L-5-1.625H5l-8.09 5.878z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m0 5.257-3.09-9.51L5 1.625H-5l8.09-5.878z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h120v60H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "none",
    stroke: "#c8102e",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m0 0 60 30M0 30 60 0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 4,
    clipPath: "url(#b)",
    d: "m0 0 60 30M0 30 60 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 10,
    d: "M30 0v31M0 15h62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0v31M0 15h62"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009cde",
    d: "M60 0h60v60H0V30h60z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 65.5,
    y: 54
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 78,
    y: 38.5
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 78,
    y: 51
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 90.5,
    y: 21.5
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 90.5,
    y: 47.5
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 101,
    y: 17.5
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 101,
    y: 38.5
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 111.5,
    y: 8
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 111.5,
    y: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.615f49d7c1c05c4ce29b36e3e371a09e.svg";
export { ForwardRef as ReactComponent };